import React from 'react';
import { FOOTER_LINKS, SUPPORT_EMAIL } from '../data/config';
export function Footer() {
  return <footer className="bg-navyDeep px-4 py-5 text-center md:px-12" data-id="element-70" data-mp="3gfiugihumbe4">
      <p className="font-heading text-[11px] font-extrabold uppercase text-white" data-id="element-71" data-mp="32nul2myzi10u">
        © 2026 Bright Digital Hub — All rights reserved.
      </p>
      <div className="mx-auto mt-1.5 max-w-[640px] space-y-1 text-[12px] leading-[1.4] text-white/70" data-id="element-72" data-mp="36q92r3qx2uqj">
        <p data-id="element-73" data-mp="3ugbpd4c2b8hr">
          Complete AAC Communication Toolkit™ provides educational resources for qualified Speech-Language Pathologists
          and trained AAC professionals. It does not replace professional education, individualized assessment, clinical
          judgment, medical care, or emergency services. Clinical decisions remain the responsibility of the treating
          professional.
        </p>
      </div>
      <nav aria-label="Legal" className="mt-1.5 text-[12px] text-white" data-id="element-74" data-mp="29xvqkc20tbos">
        {FOOTER_LINKS.map((l, i) => <React.Fragment key={l.label} data-id="element-75" data-mp="2evx98vvjb8zq" data-mpi={i}>
            {i > 0 && <span className="mx-1.5" aria-hidden data-id="element-76" data-mp="3lalf9cv8a1sw">•</span>}
            <a href={l.href} className="transition-colors duration-150 hover:text-gold" data-id="element-77" data-mp="3gah0br9yxf4s">
              {l.label}
            </a>
          </React.Fragment>)}
      </nav>
      <p className="mt-1 text-[12px] text-white" data-id="element-78" data-mp="3v5n5kc18p9x2">
        Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline hover:text-gold" data-id="element-79" data-mp="3q7u2hrv8gw10">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}